import { useCallback, useState } from 'react';

const DEFAULT_ONBOARDING_STATE = {
  // 'create' = start a new workspace/org you'll run.
  // 'join'   = find an existing org to support (sponsor / volunteer / contribute).
  intent: '',
  accountType: '',
  sector: null,
  role: '',
  // 'sample' = fill the new workspace with the canonical sample dataset so the
  // product is explorable immediately (ADR 0010); 'real' = start empty.
  //
  // Captured during the wizard but applied AFTER the workspace exists, because
  // enabling sample mode is an owner-gated call that needs a workspace id.
  dataMode: 'sample'
};

export const useSeedOnboardingPresentation = () => {
  const [onboardingState, setOnboardingState] = useState(
    DEFAULT_ONBOARDING_STATE
  );

  const updateOnboardingState = useCallback((nextState) => {
    setOnboardingState((previous) => {
      const resolved =
        typeof nextState === 'function' ? nextState(previous) : nextState;
      return { ...previous, ...(resolved || {}) };
    });
  }, []);

  const resetOnboardingState = useCallback(() => {
    setOnboardingState(DEFAULT_ONBOARDING_STATE);
  }, []);

  return {
    onboardingState,
    updateOnboardingState,
    resetOnboardingState
  };
};
